import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';
import { useStaticQuery, graphql, Link } from 'gatsby';

import Wrapper from '../../elements/wrapper';

import Wave from '../../../images/waves/home-top-wave.inline.svg';
import { media } from '../../helpers';

const HomeCTABottomBannerContainer = styled.div`
    background-color: #f2f0eb;
    margin-bottom: 10vh;
    ${media.medium`margin-bottom: 40vh;`}
    .svg-container {
        background-color: #f2f0eb;

        svg {
            width: 100%;
            height: auto;
            path {
                fill: #fff;
                opacity: 1;
            }
        }
    }
    .wave-cta-wrapper {
        padding: 100px 0 0;
        max-width: 100vw;
        ${media.medium`max-width: 90vw; padding: 100px 0;`}
        > .content-container {
            text-align: center;
            padding: 0 20px;
            ${media.medium`padding: 0;`}
            h3 {
                font-size: 4rem;
                color: #000;
                letter-spacing: -1px;
                margin: 0 0 40px;
                font-weight: 800;
                font-family: neue-kabel, sans-serif;
            }

            p {
                font-size: 1rem;
                max-width: 550px;
                margin: 0 auto 30px;
                line-height: 1.5;
            }

            .btn-container {
                padding-bottom: 7vh;
                ${media.medium`padding-bottom: 0vh;`}
                a {
                    color: #fff;
                    background-color: #f74d33;
                    text-decoration: none;
                    font-weight: bold;
                    font-size: 1.1rem;
                    border-radius: 5px;
                    line-height: 1;
                    display: inline-block;
                    padding: 20px 0;
                    max-width: 225px;
                    width: 100%;
                    font-weight: 800;
                    font-family: neue-kabel, sans-serif;
                }
            }
        }
    }
    .banner-container {
        position: relative;

        ${media.medium`bottom: -30vh;max-width: 80vw;margin: -20vh auto 0;`}

        .image-container {
            .gatsby-image-wrapper {
                min-height: 40vh;
            }
        }

        .content-container {
            ${media.medium`position: absolute;bottom: -7vh;left: 6vw;width: 100%;`}

            .inner-wrap {
                max-width: 450px;
                background-color: #f2f0eb;
                box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.12);
                padding: 50px 40px;

                h3 {
                    font-size: 2rem;
                    color: #000;
                    margin: 0 0 20px;
                    font-weight: 800;
                    font-family: neue-kabel, sans-serif;
                }
                p {
                    font-size: 1.05rem;
                    line-height: 1.5;
                    margin: 0;
                }
            }
        }
    }
`;

const HomeCTABottomBanner = () => {
    const data = useStaticQuery(graphql`
        query {
            home: allWpPage(filter: { title: { eq: "Home" } }) {
                edges {
                    node {
                        home_acf {
                            bottomCtaSettings {
                                bottomCtaContent
                                bottomCtaHeadline
                                bottomCtaImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 1400, quality: 90) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                                waveCaption
                                waveHeadline
                                waveButton {
                                    title
                                    url
                                }
                            }
                        }
                    }
                }
            }
        }
    `);
    const {
        waveHeadline,
        waveCaption,
        bottomCtaImage,
        bottomCtaHeadline,
        bottomCtaContent,
        waveButton,
    } = (data && data.home.edges[0].node.home_acf.bottomCtaSettings) || {};
    return (
        <HomeCTABottomBannerContainer>
            <div className="svg-container">
                <Wave />
            </div>
            <Wrapper className="wave-cta-wrapper">
                <div className="content-container">
                    <h3>{waveHeadline}</h3>
                    <p>{waveCaption}</p>
                    <div className="btn-container">
                        <Link to={waveButton.url}>{waveButton.title}</Link>
                    </div>
                </div>

                <div className="banner-container">
                    <div className="image-container">
                        <Img
                            fluid={
                                bottomCtaImage.localFile.childImageSharp.fluid
                            }
                        />
                        <div className="content-container">
                            <div className="inner-wrap">
                                <h3>{bottomCtaHeadline}</h3>
                                <p>{bottomCtaContent}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Wrapper>
        </HomeCTABottomBannerContainer>
    );
};

export default HomeCTABottomBanner;
